export const maxRetriesNotExceeded = ({ context }) => (context.retryCount ?? 0) < (context.maxRetries ?? 3);
export const channelAvailable = ({ context }) => !!context.channelAvailable;
//# sourceMappingURL=notification-dispatch.js.map